<template>
  <div class="navbar showSmallScreenOnly" :class="navbarStyle">
    <div class="navbar-inner no-swipeback"
      :class="{'navbar-inner-popup': !closePage && closePopup} + navbarInnerStyle"
      @click="closeCountryPickerModal">

      <!-- Menu "Hamburger" en haut à gauche des écrans de smartphones et tablette -->
      <f7-nav-left>
        <f7-link v-if="true/*!backLink*/"
          class="headbandTextColor"
          icon-fa="bars" close-picker open-panel="left">
        </f7-link>
        <!--
        <back-button v-else :backLabel="false" :returnUrl="returnUrl"
          customStyle="coflor:var(--headbandTextColor);font-size:1.5rem">
        </back-button>-->
      </f7-nav-left>

      <!-- Logo de MoneyRoad affiché sur écran mobile -->
      <div v-if="!navTitle" class="titleApp centrageLogoSmallScreen">
        <!-- La classe "streammind-icon-popup" est ajoutée s'il s'agit d'une fenêtre pop-up -->
        <p :class="{'streammind-icon-popup': closePopup}" @click="goBackHome()">
          <img :src="imgVarsLong" alt="MoneyRoadBNPP" class="heritage-mobile-header">
          <!--<f7-icon class="streammind-icon" v-bind:class="getColor"></f7-icon>-->
        </p>
      </div>
      <!-- Ou titre de la page sur écran mobile -->
      <div v-else class="headbandTextColor">
        <b>{{ navTitle }}</b>
      </div>

      <!-- Bouton cancel pour fermer la fenêtre pop-up, à la fois pour le profile et le service switcher pour eviter de rester blocker sur le panel qui ne se ferme pas en cliquant a cote-->
      <div v-if="closePopup && !closePage" class="cancelButton">
        <f7-link class="streammindContactListButton orangeFont" close-popup>{{ $t('common.cncl') }}</f7-link>
      </div>
      <div v-else-if="closePage && !returnPreviousPage">
        <f7-link class="streammindContactListButton cancelButton orangeFont">{{ $t('common.cncl') }}</f7-link>
      </div>
      <div v-else-if="returnPreviousPage">
        <f7-link class="streammindContactListButton cancelButton orangeFont">{{ $t('common.rtrn') }}</f7-link>
      </div>
      <div v-else>
       <div class="mw-44px"/>
      </div>

      <!-- Bouton d'ouverture de pop-up de service switch-->
      <!-- <f7-nav-right>
        <f7-link v-if="picker && !closePopup && !closePage && !returnPreviousPage"
          style="color: #051447" close-picker icon-fa="th" open-popup data-popup="#service-switcher-true"></f7-link>
      </f7-nav-right> -->

      <!-- subnavbar des pop-up -->
      <f7-subnavbar v-if="subNavTitle !== '' && !closePage && closePopup"
        class="subtitle-mobile-header subtitlePopup subnavbarPopup border-bottom-color-mobile-header">
        <div v-if="!closePage && closePopup" class="subNavtitlePopup">{{subNavTitle}}</div>
      </f7-subnavbar>

      <!-- subnavbar des fenêtres sauf sur les pop-up -->
      <f7-subnavbar v-else-if="subNavTitle !== ''" class="subtitle-mobile-header border-bottom-color-mobile-header" >
        <!-- Bouton pour revenir en arrière sur smartphone -->
        <div class="returnButtonMarginLeft">
          <f7-link v-if="ReturnButton" class="color-grey-mobile-header" close-picker>
            <i class="fa-solid fa-play rotate-180deg"></i>
          </f7-link>
        </div>
        <div class="subNavtitle">{{subNavTitle}}</div>
        <!-- Bouton d'aide s'il est demandé, sinon il est remplacé par un espace vide -->
        <div v-if="popoverName" class="popoverNamePaddingRight">
          <f7-link class="open-popover color-grey-mobile-header"
            href="#"
            :data-popover="popoverName">
            <i class="fa-duotone fa-square-question"></i>
          </f7-link>
        </div>
        <div v-else>
          <div class="ml-15px"></div>
        </div>
      </f7-subnavbar>
    </div>
  </div>
</template>

<script>
import design from '@/design/design.json'

// import backButton from '@/components/common/backButton.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

/* Panneau de gauche sur petits écran (smartphones et tablettes) */
export default {
  name: 'MobileHeader',
  components: {
    // 'back-button': backButton
  },
  props: {
    closePage: {
      type: Boolean,
      default: false
    },
    closePopup: {
      type: Boolean,
      default: false
    },
    currentServiceName: {
      type: String,
      default: ''
    },
    menuAccess: {
      type: Boolean,
      default: false
    },
    navbarStyle: {
      type: String,
      default: ''
    },
    picker: {
      type: Boolean,
      default: true
    },
    popoverName: {
      type: String,
      default: ''
    },
    ReturnButton: {
      type: Boolean,
      default: false
    },
    returnPreviousPage: {
      type: Boolean,
      default: false
    },
    subNavTitle: {
      type: String,
      default: ''
    },
    switchService: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      design: design.menu,
      service: '',
      icon: '',
      backLink: false,
      color: '',
      headerHistory: [],
      navbarInnerStyle: '',
      navTitle: '',
      returnUrl: 'none',
      windowWidth: window.innerWidth
    }
  },
  computed: {
    imgVarsLong () {
      return this.design.headbandLogoLong
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    // this.service = this.$engine.user.currentService.name

    this.icon = this.getIcon(this.service)
    this.color = this.getServiceColor(this.service)
    this.white = '#000000'

    let that = this
    this.$bus.$on('change-mobile-header', function (e) {
      that.backLink = e.backLink
      that.navbarInnerStyle = e.navbarInnerStyle
      that.navTitle = e.navTitle
      that.returnUrl = e.returnUrl
      that.headerHistory.unshift(e)
      if (that.headerHistory.length > 4) {
        that.headerHistory.length = 4
      }
    })
    this.$bus.$on('router-back', function () {
      that.headerHistory.shift()
      let e = that.headerHistory[0]
      that.backLink = e.backLink
      that.navbarInnerStyle = e.navbarInnerStyle
      that.navTitle = e.navTitle
      that.returnUrl = e.returnUrl
    })
    // if (this.windowWidth >= 1024) {
    //   this.updateNotifications()
    // }
  },
  mounted () {
    this.$bus.$on('service:change', (val) => {
      this.service = val
      this.icon = this.getIcon(this.service)
      this.color = this.getServiceColor(this.service)
    })
  },
  methods: {
    handleResize () {
      let that = this
      that.windowWidth = window.innerWidth
      that.$bus.emit('window-resize')
    },
    getIcon (service) {
      switch (service) {
        case 'Direct Debit':
          return 'icon-directDebit'
        case 'Payments':
          return 'icon-payments'
        default: // Direct Payments pour la démo
          return 'icon-directPayments'
      }
    },
    getServiceColor (service) {
      switch (service) {
        case 'Direct Debit':
          return '#572B74'
        case 'Payments':
          return '#51A45C'
        default: // Direct Payments pour la démo
          return '#12BCF1'
      }
    },
    closeCountryPickerModal () {
      this.$f7.closeModal('.countryListPicker')
    },
    showProfile () {
      loadPage(this, {url: '/profile/'})
    },
    activateModal () {
      this.$f7.popup('#service-switcher-true')
    },
    goBackHome () {
      var that = this
      loadPage(that, {url: '/home/'})
    },
    /* Ouverture du panneau de gauche (menu hamburger) et ajout des nombres de notifications */
    updateNotifications () {
      let that = this
      /** TLV 24/09/2019
      * Adaptation du modèle appelé en fonction du type de fonctionnalité sur le panneau de gauche
      * Payments --> Appel à payment/isRead
      * Direct Payments --> Appel à directPayment/isRead
      */
      if (this.$engine.user.currentService.name === 'Payments') {
        this.$engine.services.payments.getPaymentsNotReadNumber()
        .then(resp => {
          if (resp.data.requestNotReadNumber > 99) {
            that.Dom7('.numberBadge').text('99+')
          } else {
            that.Dom7('.numberBadge').text(resp.data.requestNotReadNumber)
          }
          /* eslint-disable no-undef */
          // Affichage des notifications sur mobile, provoque une erreur en console sur version web
          if (that.$engine.services.directPayments.filter.smartphoneStorage) {
            // cordova.plugins.notification.badge.set(resp.data.requestNotReadNumber)
          }
          /* eslint-enable no-undef */
        })
        .catch(error => {
          // console.log(error)
          errorMessageAlert(error, that)
        })
      } else if (this.$engine.user.currentService.name === 'Direct Payments') {
        this.$engine.services.directPayments.getPaymentsNotReadNumber()
        .then(resp => {
          if (resp.data.requestNotReadNumber > 99) {
            that.Dom7('.numberBadge').text('99+')
          } else {
            that.Dom7('.numberBadge').text(resp.data.requestNotReadNumber)
          }
          /* eslint-disable no-undef */
          // Affichage des notifications sur mobile, provoque une erreur en console sur version web
          if (that.$engine.services.directPayments.filter.smartphoneStorage) {
            // cordova.plugins.notification.badge.set(resp.data.requestNotReadNumber)
          }
          /* eslint-enable no-undef */
        })
        .catch(error => {
          // console.log(error)
          errorMessageAlert(error, that)
        })
      } else if (this.$engine.user.currentService.name === 'Direct Debit') {
        this.$engine.services.directDebit.getPaymentsNotReadNumber()
        .then(resp => {
          if (resp.data.requestNotReadNumber > 99) {
            that.Dom7('.numberBadge').text('99+')
          } else {
            that.Dom7('.numberBadge').text(resp.data.requestNotReadNumber)
          }
          /* eslint-disable no-undef */
          // Affichage des notifications sur mobile, provoque une erreur en console sur version web
          if (that.$engine.services.directPayments.filter.smartphoneStorage) {
            // cordova.plugins.notification.badge.set(resp.data.requestNotReadNumber)
          }
          /* eslint-enable no-undef */
        })
        .catch(error => {
          // console.log(error)
          errorMessageAlert(error, that)
        })
      }
    },
    /* TLV 09/12/2019
    * Fonction qui redirige l'utilisateur en fonction du service qu'il utilise
    */
    redirectionPage (service) {
      let link = ''

      switch (service) {
        case 'Payments' :
          link = '/dashboard/'
          break
        case 'Direct Payments' :
          link = '/directPayments/inbox/'
          break
        case 'Direct Debit' :
          link = '/directDebit/inbox/'
          break
        default :
          break
      }
      // TLV 25/11/2019 : Bouton de déconnexion depuis la navbar
      if (service === '') {
        this.$bus.emit('logout')
      }
      // Autres boutons de la navbar
      loadPage(this, {url: link})
    }
  }
}
</script>

<style>
</style>
